import { createContext, useContext, useState } from "react";

const TooltipModeContext = createContext();

export function TooltipModeProvider({ children }) {
  const [mode, setMode] = useState("simple"); // "simple" | "detailed"

  return (
    <TooltipModeContext.Provider value={{ mode, setMode }}>
      {children}
    </TooltipModeContext.Provider>
  );
}

export function useTooltipMode() {
  return useContext(TooltipModeContext);
}
